import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-walking': {
			// /walking-m?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_walking_male_bulk_change~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_walking_male_bulk_change'),
			},
			// /walking-m?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_walking_male_bulk_change~1
			funnel: {
				id: 'ob-male-walking-bulk-change',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_walking_male_bulk_change~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_walking_male_bulk_change'),
			},
		},
	},
]

export default config
